module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon4.21da9cc5a70bf66b36596318d95b82df.png";